// extracted by mini-css-extract-plugin
export default {"global":"mobile_global__14pnx","content":"mobile_content__u+xQ5","music":"mobile_music__JLMeR","play":"mobile_play__NQT7x","spin":"mobile_spin__0BYwz"};